<template>
  <bkf-form-simple
    v-if="show"
    ref="form"
    :form-url="`${actionUrl}/new`"
    :action-url="actionUrl"
    :context="null"
    :entry="alertRule"
    :options="{}"
    :hide-submit-button="true"
    submit-text="dialog.add"
    request-method="post"
    @fetching="onFetching"
    @fetched="onFetched"
    @fetchError="onFetchError"
    @submitting="onSubmitting"
    @submitted="onSubmitted"
    @submitError="onSubmitError"
    @validate-error="onValidateError"
  />
</template>

<script>
import BkfFormSimple from '@components/libs/forms/Form/Form.vue';

export default {
  components: { BkfFormSimple },
  props: {
    model: {
      type: Function,
      required: false,
      default: null,
    },
    alertRule: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    actionUrl: 'alertrules',
    show: false,
    fetching: false,
    entries: [],
    conditions: [],
    config: {
      multiSelect: false,
    },
  }),
  mounted() {
    this.fetching = true;
    this.show = true;
    this.onEditing();
  },
  methods: {
    onFetching() {
      this.fetching = true;
      this.$emit('fetching');
    },
    onFetched() {
      this.fetching = false;
      this.$emit('fetched');
    },
    onFetchError(payload) {
      this.fetching = false;
      this.show = false;
      this.$emit('fetch-error', payload);
    },
    onSubmitting() {
      this.submitting = true;
    },
    async onSubmitted(payload) {
      this.$emit('submitted', payload);
    },
    async onSubmitError(payload) {
      this.$emit('create-error', payload);
    },
    onValidateError() {
      this.submitting = false;
      this.$emit('validate-error');
    },
    onEditing() {
      if (this.alertRule) {
        this.$emit('editing');
      }
    },
  },
};
</script>
